import { FETCH_AUTH_INFO } from "@/store/action-types"

export default async function verify({ next, store }) {

    const isLogin = await store.state.auth.isLoggedIn

    if (!isLogin) {
        next('/login')
        return
    }


    await store.dispatch(FETCH_AUTH_INFO)

    let user = store.state.auth.authUser

    let emailVerifiedAt = null

    if (user) {
        emailVerifiedAt = user.emailVerifiedAt;
    }

    if (!isLogin || !user || emailVerifiedAt != null) next('/login')


    else next()

}